module.exports = __webpack_public_path__ + "00d6d9263ba58f99f91cabfc1a8fd5d9.png";